/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  AppointmentReminderPreferenceRequest,
  AppointmentReminderPreferenceResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AppointmentReminderPreferenceRequestFromJSON,
    AppointmentReminderPreferenceRequestToJSON,
    AppointmentReminderPreferenceResponseFromJSON,
    AppointmentReminderPreferenceResponseToJSON,
} from '../models/index';

export interface FindAppointmentReminderPreferencesRequest {
    instituteId: string;
}

export interface UpdateAppointmentReminderPreferencesRequest {
    reminderPreferenceId: string;
    appointmentReminderPreferenceRequest: AppointmentReminderPreferenceRequest;
}

/**
 * 
 */
export class ReminderPreferenceApi extends runtime.BaseAPI {

    /**
     */
    async findAppointmentReminderPreferencesRaw(requestParameters: FindAppointmentReminderPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentReminderPreferenceResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findAppointmentReminderPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instituteId'] != null) {
            queryParameters['institute_id'] = requestParameters['instituteId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/reminder-preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentReminderPreferenceResponseFromJSON(jsonValue));
    }

    /**
     */
    async findAppointmentReminderPreferences(requestParameters: FindAppointmentReminderPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentReminderPreferenceResponse> {
        const response = await this.findAppointmentReminderPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAppointmentReminderPreferencesRaw(requestParameters: UpdateAppointmentReminderPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reminderPreferenceId'] == null) {
            throw new runtime.RequiredError(
                'reminderPreferenceId',
                'Required parameter "reminderPreferenceId" was null or undefined when calling updateAppointmentReminderPreferences().'
            );
        }

        if (requestParameters['appointmentReminderPreferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentReminderPreferenceRequest',
                'Required parameter "appointmentReminderPreferenceRequest" was null or undefined when calling updateAppointmentReminderPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/reminder-preferences/{reminder_preference_id}`.replace(`{${"reminder_preference_id"}}`, encodeURIComponent(String(requestParameters['reminderPreferenceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentReminderPreferenceRequestToJSON(requestParameters['appointmentReminderPreferenceRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAppointmentReminderPreferences(requestParameters: UpdateAppointmentReminderPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAppointmentReminderPreferencesRaw(requestParameters, initOverrides);
    }

}
